import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { BrandsState } from '../../model/model'
import { Brand } from '../../model/brands'

const initialState: BrandsState = []

export const slice = createSlice({
	name: 'brands',
	initialState,
	reducers: {
		_loadBrands: (state, { payload }: PayloadAction<Brand[]>) => payload,
	},
})

export default slice.reducer
